import React, { useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import CreateClaim from "./CreateClaim";
import ClaimInfo from "./ClaimInfo";
import CancelClaim from "./CancelClaim";
import { useDispatch } from "react-redux";
import {
  useTrackJeeblyOrderMutation,
  useCancelJeeblyOrderMutation,
} from "redux/Logistic/JeeblyService";
import { UTILS } from "utils";
import { LoaderAction } from "redux/actions";
import { errorHandler } from "api/api/errorHandler";
import ModalTabs from "logistic-integrations/components/Tabs";
import JeeblySupport from "./JeeblySupport";
const { TabPane } = Tabs;
const DeliveryService = (props) => {
  const { t } = useTranslation();
  const { setOpen, order } = props;
  const dispatch = useDispatch();
  const [jeeblyOrder, setJeeblyOrder] = useState(null);
  const [trackJeeblyOrder] = useTrackJeeblyOrderMutation();
  const [cancelJeeblyOrder] = useCancelJeeblyOrderMutation();

  /*handle tab chnge */
  const handleTabChange = async (key) => {
    if (key === "3") {
      await getJeeblyOrderStatus();
    }
    await props.fetchOrderDetailsByID();
  };

  const getJeeblyOrderStatus = async () => {
    try {
      if (!order?._id) return;
      dispatch(LoaderAction.setLoading(true));
      const data = await trackJeeblyOrder({
        orderId: order._id,
      });
      if (data?.data?.success === 1 && data?.data?.data) {
        setJeeblyOrder(data?.data.data);
      } else {
        UTILS.errorNotification(errorHandler(data?.error));
        setJeeblyOrder(null);
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const canceljeeblyOrder = async () => {
    try {
      dispatch(LoaderAction.setLoading(true));
      if (!order?._id) return;
      const data = await cancelJeeblyOrder({
        orderId: order._id,
      });
      if (data?.data?.success === 1) {
        UTILS.successNotification(
          data?.data?.message || t("Order has been cancelled successfully")
        );
      } else {
        UTILS.errorNotification(errorHandler(data?.error));
      }
      await props.fetchOrderDetailsByID();
    } catch (error) {
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  return (
    <ModalTabs setOpen={setOpen} handleTabChange={handleTabChange}>
      <TabPane tab={t("SEND ORDER")} key="1">
        <CreateClaim
          fetchOrderDetailsByID={props.fetchOrderDetailsByID}
          customKey="create-claim"
        />
      </TabPane>
      <TabPane tab={t("ORDER DETAIL")} key="3">
        <ClaimInfo
          key="order-status"
          jeeblyOrder={jeeblyOrder}
          getjeeblyOrderStatus={getJeeblyOrderStatus}
        />
      </TabPane>
      <TabPane tab={t("CANCEL ORDER")} key="4">
        <CancelClaim
          key="cancel-claim"
          canceljeeblyOrder={canceljeeblyOrder}
          jeeblyOrder={jeeblyOrder}
        />
      </TabPane>
      <TabPane tab={t("JEEBLY SUPPORT CENTER")} key="5">
        <JeeblySupport jeeblyOrder={jeeblyOrder} />
      </TabPane>
    </ModalTabs>
  );
};

export default DeliveryService;
